import axios from "axios";

const productionAxios = axios.create({
  baseURL: "https://esystems.cdl.lk/backend-test/AttendMe2",
});

// Forward auth token from global axios defaults
productionAxios.interceptors.request.use((config) => {
  const token =
    axios.defaults.headers.common["Authorization"] ||
    axios.defaults.headers.common["token"];
  if (token) config.headers["Authorization"] = token;
  return config;
});

const AccumulatedService = {

  GetActultimeduration: () =>
    productionAxios.get("Production/GetActultimeduration"),

  GetIwoGroupByAdditional: () =>
    productionAxios.get("Production/GetIwoGroupByAdditional"),

  GetJobHours: (iwoList) =>
    productionAxios.get("Production/GetJobHours", {
      params: { IwoList: iwoList },
      paramsSerializer: (params) => {
        return params.IwoList
          .map(iwo => `IwoList=${encodeURIComponent(iwo)}`)
          .join("&");
      },
    }),
};

export default AccumulatedService;